<ion-card
  mode="ios"
  color="getm-neutral-white"
  class="card-favs-control"
  [ngStyle]="{
    'min-height':
      favsControlFormat.estatus === estatusProgreso
        ? '84px'
        : favsControlFormat.estatus === estatusCompletado ||
          favsControlFormat.estatus === estatusExpirado
        ? '60px'
        : '48px'
  }"
>
  <ng-container [ngSwitch]="favsControlFormat.estatus">
    <!-- ? Estatus 2 - Progreso -->
    <ng-container *ngSwitchCase="estatusProgreso">
      <ion-item
        color="transparent"
        mode="md"
        lines="none"
        class="header-progress"
      >
        <ion-label
          [translateFormatter]="'Labels.buy-favs-products-and-win' | translate"
          class="buy-favs-products-and-win"
          color="getm-disabled-dark"
        >
        </ion-label>

        <section slot="end" class="space-gap">
          <getm-coins-badge
            size="small"
            [text]="'+' + (favsControlFormat.puntosPremio | number : '1.0-0')"
          />
        </section>
      </ion-item>

      <ion-item
        color="transparent"
        mode="md"
        lines="none"
        class="header-progress"
      >
        <getm-favs-progress-bar
          [value]="favsControlFormat.skuLiquidados"
          [maxValue]="favsControlFormat.skuObjetivos"
        ></getm-favs-progress-bar>

        <section slot="end" class="space-gap">
          <getm-tag-card-img
            icon="getm-fav"
            slotIcon="right"
            [label]="favsControlFormat.skuObjetivos + ''"
            color="getm-category-gana-mas"
            size="small"
          ></getm-tag-card-img>
        </section>

        <ion-text
          color="getm-disabled-dark"
          slot="end"
          class="space-gap ends-in"
          [translateFormatter]="favsControlFormat?.diasDiferenciaVigencia || ''"
        >
        </ion-text>
      </ion-item>
    </ng-container>

    <!-- ? Estatus 3 - Completado -->
    <ng-container *ngSwitchCase="estatusCompletado">
      <ion-grid fixed class="ion-no-padding">
        <ion-row class="row-completed ion-align-items-center">
          <ion-col size="5.7">
            <ion-text color="getm-disabled-dark" class="bought">
              {{ 'Labels.bought' | translate }}
            </ion-text>

            <getm-tag-card-img
              icon="getm-fav"
              slotIcon="right"
              [label]="favsControlFormat.skuLiquidados + ''"
              color="getm-category-gana-mas"
              size="small"
            ></getm-tag-card-img>
          </ion-col>

          <ion-col size="6.3">
            <section class="section-swiper-container">
              <ion-grid class="ion-no-padding component-slider-box">
                <section
                  class="slider-wrapper"
                  [style.transform]="'translateY(-' + activeSlide * 50 + '%)'"
                >
                  <ion-row class="slide-item ion-align-items-center">
                    <ion-col size="12" class="ion-text-right">
                      <ion-text color="getm-disabled-dark" class="you-won">
                        {{ 'Labels.you-won!' | translate }}
                      </ion-text>

                      <ion-chip
                        color="getm-warning-default"
                        mode="ios"
                        [outline]="true"
                        class="chip-puntos-premio"
                      >
                        <getm-coins-badge
                          size="small"
                          [text]="
                            '+' +
                            (favsControlFormat.puntosPremio | number : '1.0-0')
                          "
                        />
                      </ion-chip>
                    </ion-col>
                  </ion-row>

                  <ion-row class="slide-item ion-align-items-center">
                    <ion-col size="12" class="ion-text-right">
                      <ion-label
                        color="getm-disabled-dark"
                        class="new-challenge-in"
                        [translateFormatter]="
                          favsControlFormat?.diasDiferenciaProximo || ''
                        "
                      >
                      </ion-label>
                    </ion-col>
                  </ion-row>
                </section>
              </ion-grid>
            </section>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-container>

    <!-- ? Estatus 4 - No completado -->
    <ng-container *ngSwitchCase="estatusExpirado">
      <ion-item
        color="transparent"
        mode="md"
        lines="none"
        class="header-progress"
      >
        <ion-text color="getm-disabled-dark" class="bought">
          {{ 'Labels.bought' | translate }}
        </ion-text>

        <getm-tag-card-img
          icon="getm-fav"
          slotIcon="right"
          [label]="favsControlFormat.skuLiquidados + ''"
          color="getm-category-gana-mas"
          size="small"
        ></getm-tag-card-img>

        <ion-text
          color="getm-disabled-dark"
          slot="end"
          class="space-gap new-challenge-in"
          [translateFormatter]="favsControlFormat?.diasDiferenciaProximo || ''"
        >
        </ion-text>
      </ion-item>
    </ng-container>

    <!-- ! Error -->
    <ng-container *ngSwitchDefault>
      <ion-item
        color="transparent"
        mode="md"
        lines="none"
        class="header-progress item-error"
      >
        <ion-text
          color="getm-disabled-dark"
          class="new-challenge-in"
          [translateFormatter]="'Labels.loading-favs-progress' | translate"
        >
        </ion-text>
      </ion-item>
    </ng-container>
  </ng-container>
</ion-card>
